module.exports = __webpack_public_path__ + "img/oufu_74x95x11b.prt.5fab944d.jpg";